import { defineMessages } from 'react-intl-next';

export const messages: {
	pin_title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pin_title_suggested: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pin_icon_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	add_another_pin_button_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	add_pin_button_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	learn_about_pins: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	add_pin_card_copy: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalAddPinHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalSubheaderLine1: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalSubheaderLine2: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalPinDetailsHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalPinDetailsSubHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalSearchResultTitleHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalSearchResultTitlePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalUrlHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalUrlPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalDescriptionHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalDescriptionPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalSearchForTermsHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalSearchForTermsPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalSearchForTermsTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalCancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalAddButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalNoTitleMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalNoUrlMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinModalInvalidUrlMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinPhraseCollisionErr: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinKeyPhraseTooLongErr: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinKeyPhraseHasSpecialCharErr: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinKeyPhraseListTooLongErr: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinKeyPhraseListTooShortErr: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinKeyPhraseListNonUniqueErr: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinExists: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinGenericErrorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinUpdateErrorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinCreationSuccessFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinCreationSuccessFlagMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinSuggestionMainMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinSuggestionSubMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinCompanyAddedTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinSuggestedTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinCopyUrlTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pinFeedbackSubmittedFlagMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bookmarkEditTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bookmarkModalUpdateHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bookmarkModalUpdateButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bookmarkUpdateSuccessFlagTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	userCreatedBookmarksFeatureTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	pin_title: {
		id: 'search_ai.bookmark.title',
		defaultMessage: 'Bookmarked by your company',
		description: 'Text for the bookmark card title',
	},
	pin_title_suggested: {
		id: 'search_ai.bookmark.title_suggested',
		defaultMessage: 'Bookmark suggested by Rovo',
		description: 'Text for the suggested bookmark card title',
	},
	pin_icon_label: {
		id: 'search_ai.bookmark.icon_label',
		defaultMessage: 'Search bookmark icon',
		description: 'Text for the search bookmark icon label',
	},
	add_another_pin_button_label: {
		id: 'search_ai.bookmark.add_another_pin_button',
		defaultMessage: 'Add another bookmark',
		description: 'Text for the add another bookmark button',
	},
	add_pin_button_label: {
		id: 'search_ai.bookmark.add_pin_button',
		defaultMessage: 'Add bookmark',
		description: 'Text for the add bookmark button',
	},
	learn_about_pins: {
		id: 'search_ai.bookmark.info_link',
		defaultMessage: 'Learn more about bookmarks',
		description: 'Link to learn more about bookmark',
	},
	add_pin_card_copy: {
		id: 'search_ai.bookmark.add_pin_card_copy',
		defaultMessage: 'Add a bookmark so your teammates find things faster',
		description: 'Copy for the add bookmark card',
	},
	dismiss: {
		id: 'search_ai.bookmark.add_pin_dismiss',
		defaultMessage: 'Dismiss',
		description: 'Link to dismiss the add bookmark card',
	},
	pinModalAddPinHeader: {
		id: 'search_ai.bookmark.modal-add-header',
		defaultMessage: 'Add a new bookmark',
		description: 'Header for modal when adding a new bookmark',
	},
	pinModalSubheaderLine1: {
		id: 'search_ai.bookmark.modal-subheader-line-1',
		defaultMessage:
			'Bookmarks allow you to show a search result first, based on particular search terms.',
		description: 'Subheader text for modal when adding a bookmark',
	},
	pinModalSubheaderLine2: {
		id: 'search_ai.bookmark.modal-subheader-line-2',
		defaultMessage: 'You can also create and manage bookmarks from <a>Admin Hub.</a>',
		description:
			'Subheader text for modal when adding a bookmark. original text: You can also create and manage bookmarks from Admin Hub.',
	},
	pinModalPinDetailsHeader: {
		id: 'search_ai.bookmark.modal-pin-details',
		defaultMessage: 'Bookmark details',
		description: 'Header for modal form',
	},
	pinModalPinDetailsSubHeader: {
		id: 'search_ai.bookmark.modal-pin-details-subheader',
		defaultMessage:
			'Everyone in your organization will see this result when they search for the terms.',
		description: 'Subheader for bookmark details',
	},
	pinModalSearchResultTitleHeader: {
		id: 'search_ai.bookmark.modal-search-result-title-header',
		defaultMessage: 'Search result title',
		description: 'Header for search result title input box',
	},
	pinModalSearchResultTitlePlaceholder: {
		id: 'search_ai.bookmark.modal-search-result-title-placeholder',
		defaultMessage: 'Enter a title for this bookmark',
		description: 'Placeholder for search result title input box',
	},
	pinModalUrlHeader: {
		id: 'search_ai.bookmark.modal-url-header',
		defaultMessage: 'URL',
		description: 'Header for url input box',
	},
	pinModalUrlPlaceholder: {
		id: 'search_ai.bookmark.modal-url-placeholder',
		defaultMessage: 'Enter internal or external URL for this bookmark',
		description: 'Placeholder for url input box',
	},
	pinModalDescriptionHeader: {
		id: 'search_ai.bookmark.modal-description-header',
		defaultMessage: 'Description',
		description: 'Header for description input box',
	},
	pinModalDescriptionPlaceholder: {
		id: 'search_ai.bookmark.modal-description-placeholder',
		defaultMessage: 'Enter a short description for this bookmark',
		description: 'Placeholder for description input box',
	},
	pinModalSearchForTermsHeader: {
		id: 'search_ai.bookmark.modal-search-terms-header',
		defaultMessage: 'Search terms',
		description: 'Header for search terms input box',
	},
	pinModalSearchForTermsPlaceholder: {
		id: 'search_ai.bookmark.modal-search-terms-placeholder',
		defaultMessage: 'Enter up to 5 terms to display this bookmark',
		description: 'Placeholder for search terms input box',
	},
	pinModalSearchForTermsTooltip: {
		id: 'search_ai.bookmark.modal-search-terms-tooltip',
		defaultMessage:
			'Enter up to 5 terms that people can search for to display this bookmark. Terms can have multiple words ("leave policy"). Press enter to add a new term.',
		description: 'Tooltip for search terms input box',
	},
	pinModalCancelButton: {
		id: 'search_ai.bookmark.modal-cancel-button',
		defaultMessage: 'Cancel',
		description: 'Cancel button',
	},
	pinModalAddButton: {
		id: 'search_ai.bookmark.modal-add-button',
		defaultMessage: 'Add',
		description: 'Add button',
	},
	pinModalNoTitleMessage: {
		id: 'search_ai.bookmark.modal-no-title-msg',
		defaultMessage: 'You must add a bookmark title.',
		description: 'Message when user has not added bookmark title',
	},
	pinModalNoUrlMessage: {
		id: 'search_ai.bookmark.modal-no-url-msg',
		defaultMessage: 'You must add a bookmark URL.',
		description: 'Message when user has not added bookmark url',
	},
	pinModalInvalidUrlMessage: {
		id: 'search_ai.bookmark.modal-invalid-url-msg',
		defaultMessage: "You must add a valid absolute URL, for example 'http://www.atlassian.com'.",
		description: 'Message when user has not added a valid bookmark url',
	},
	pinPhraseCollisionErr: {
		id: 'search_ai.bookmark.modal-collision-err',
		defaultMessage:
			// eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
			'{keyPhrases} {numKeyPhrases, plural, =1 {keyword is already used for another bookmark.} other {keywords are already used for another bookmark.}}',
		description: 'Error message when keyphrase collides with another bookmark',
	},
	pinKeyPhraseTooLongErr: {
		id: 'search_ai.bookmark.modal-too-long-err',
		defaultMessage: "A search term can't be more than 50 characters.",
		description: 'Error message when keyphrase is too long',
	},
	pinKeyPhraseHasSpecialCharErr: {
		id: 'search_ai.bookmark.modal-has-special-char-err',
		defaultMessage: 'A search term can only contain letters, numbers, or spaces.',
		description: 'Error message when keyphrase contains a special character',
	},
	pinKeyPhraseListTooLongErr: {
		id: 'search_ai.bookmark.modal-list-too-long-err',
		defaultMessage: 'Maximum of 5 search terms per bookmark.',
		description: 'Error message when user tries to enter in more than 5 keyphrases',
	},
	pinKeyPhraseListTooShortErr: {
		id: 'search_ai.bookmark.modal-list-too-short-err',
		defaultMessage: 'You must add at least one term.',
		description: 'Error message when user has not added a keyphrase',
	},
	pinKeyPhraseListNonUniqueErr: {
		id: 'search_ai.bookmark.modal-list-non-unique-err',
		defaultMessage: 'Each term must be unique.',
		description:
			'Error message when user tries to enter in keyphrase that has already been entered',
	},
	pinExists: {
		id: 'search_ai.bookmark.modal-keyphrase-exists-err',
		defaultMessage: 'This bookmark already exists.',
		description: 'Error message when a keyphrase already exists',
	},
	pinGenericErrorMessage: {
		id: 'search_ai.bookmark.generic-error-msg',
		defaultMessage:
			"Something went wrong and we couldn't add your bookmark. Wait a few moments and try again.",
		description: 'Message when a generic error occurs',
	},
	pinUpdateErrorMessage: {
		id: 'search_ai.bookmark.update-error-msg',
		defaultMessage:
			"Something went wrong and we couldn't edit your bookmark. Wait a few moments and try again.",
		description: 'Message when a generic error occurs',
	},
	pinCreationSuccessFlagTitle: {
		id: 'search_ai.bookmark.pin-creation-success-title',
		defaultMessage: 'Search pin was added',
		description: 'Success notification title when a bookmark was successfully created',
	},
	pinCreationSuccessFlagMessage: {
		id: 'search_ai.bookmark.pin-creation-success-message',
		defaultMessage: 'People will see it when they search for the terms you added.',
		description: 'Success notification message when a bookmark was successfully created',
	},
	pinSuggestionMainMessage: {
		id: 'search_ai.bookmark.pin-suggestion-main-message',
		defaultMessage: 'Your teammates are searching for "{suggestedTerm}" a lot',
		description: 'Main message for bookmark suggestion',
	},
	pinSuggestionSubMessage: {
		id: 'search_ai.bookmark.pin-suggestion-sub-message',
		defaultMessage: 'Add a bookmarked link so your teammates find things faster.',
		description: 'Sub message for bookmark suggestion',
	},
	pinCompanyAddedTooltip: {
		id: 'search_ai.bookmark.pin-company-added-tooltip',
		defaultMessage: 'This result was prioritized by your admin to help you quickly find it.',
		description: 'Tooltip for admin-added bookmark',
	},
	pinSuggestedTooltip: {
		id: 'search_ai.bookmark.pin-suggested-tooltip',
		defaultMessage: "This result was suggested by AI based on your company's content.",
		description: 'Tooltip for Rovo-suggested bookmark',
	},
	pinCopyUrlTooltip: {
		id: 'search_ai.bookmark.pin-copy-url-tooltip',
		defaultMessage: 'Copy bookmark URL',
		description: 'Tooltip for bookmark copy url button',
	},
	pinFeedbackSubmittedFlagMessage: {
		id: 'search_ai.bookmark.feedback-submitted-flag-message',
		defaultMessage: 'We appreciate you taking the time to send this feedback',
		description: 'Message when user submits feedback for bookmark',
	},
	bookmarkEditTooltip: {
		id: 'search_ai.bookmark.edit-tooltip',
		defaultMessage: 'Edit bookmark',
		description: 'Tooltip for bookmark edit button',
	},
	bookmarkModalUpdateHeader: {
		id: 'search_ai.bookmark.modal-update-header',
		defaultMessage: 'Edit bookmark',
		description: 'Header for modal when editing a bookmark',
	},
	bookmarkModalUpdateButton: {
		id: 'search_ai.bookmark.modal-update-button',
		defaultMessage: 'Save',
		description: 'Save button',
	},
	bookmarkUpdateSuccessFlagTitle: {
		id: 'search_ai.bookmark.update-success-title',
		defaultMessage: 'Bookmark was updated',
		description: 'Success notification title when a bookmark was successfully updated',
	},
	userCreatedBookmarksFeatureTitle: {
		id: 'search_ai.bookmark.user-created-feature-title',
		defaultMessage: 'user-created bookmarks',
		description: 'Feature title for user-created bookmarks feedback modal',
	},
});
